/* ------------------------------------------------------------------
   PDP 2026 — sizes on the page on mobile (2026-09, CRO "plan A").
   Loaded by snippets/product-variant-picker.liquid (page copy only) and
   active only on the PDP 2026 template (.pdp-v2) below 750px.

   - The floating buy card (.pdp-buycard, main-product-v2) only shows once
     the in-page "Añadir al carrito" has scrolled away UP; while the grid /
     button are on screen or still below, it stays hidden (.nc-hold).
   - Buy card button: no size picked → scrolls back to the size grid;
     size picked → clicks the in-page button (add to cart, or "Avísame"
     when that size is sold out). Its label follows the in-page button.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__ncPdpInlineSizes) return;
  window.__ncPdpInlineSizes = true;

  function init() {
    var root = document.querySelector('.main-content-product.pdp-v2');
    if (!root) return;
    var mq = window.matchMedia('(max-width: 749px)');

    var info = root.querySelector('.product__info-container');
    var picker = info && info.querySelector('variant-radios, variant-selects');
    var buyWrap = info && info.querySelector('.product-info-buy-btn-normal');
    var card = document.querySelector('.pdp-buycard');
    if (!info || !buyWrap || !card) return;

    var cardBtn = card.querySelector('.pdp-buycard__btn');
    var addBtn = buyWrap.querySelector('button[name="add"]');
    var notifyBtn = buyWrap.querySelector('.product-form__notify');
    var cardDefault = cardBtn ? cardBtn.textContent.trim() : '';

    function visible(el) {
      return !!(el && el.offsetParent !== null && !el.classList.contains('hidden') && !el.hidden);
    }
    function picked() {
      return picker ? picker.querySelector('input[type="radio"]:checked') : null;
    }

    // ---- when does the card float? as soon as the in-page "Añadir al
    // carrito" button itself has scrolled up out of view (not the whole
    // block with the express button + installments under it). nc-show /
    // nc-hold are the only switches; the theme's own is-visible (tied to
    // the old sheet trigger) no longer decides. CSS keeps it away while the
    // size sheet is open or the footer is on screen.
    var passed = false;
    function hold() {
      var on = mq.matches && passed;
      card.classList.toggle('nc-hold', mq.matches && !passed);
      card.classList.toggle('nc-show', on);
    }
    // watch the buttons box (add-to-cart / Avísame + express button): the
    // add button alone is display:none while a sold-out size is picked.
    // The card comes in once that box is 56px from the top (about under
    // the sticky header), i.e. a little before it is fully gone.
    var watch = buyWrap.querySelector('.product-form__buttons') || buyWrap;
    var EDGE = 56;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        passed = !e.isIntersecting && e.boundingClientRect.bottom < EDGE;
        hold();
      }, { threshold: 0, rootMargin: '-' + EDGE + 'px 0px 0px 0px' }).observe(watch);
    }
    hold();
    if (mq.addEventListener) mq.addEventListener('change', hold);

    // ---- card label follows the in-page button
    function syncLabel() {
      if (!cardBtn) return;
      if (!picked()) {
        cardBtn.textContent = cardDefault;
        return;
      }
      var src = visible(notifyBtn) ? notifyBtn : addBtn;
      var txt = src ? src.textContent.replace(/\s+/g, ' ').trim() : '';
      if (txt) cardBtn.textContent = txt;
    }
    if (picker) {
      picker.addEventListener('change', function () {
        // the theme swaps the buttons after its own change handler
        setTimeout(syncLabel, 60);
        setTimeout(syncLabel, 400);
      });
    }
    syncLabel();

    // ---- card button: act on the in-page selection (capture: beats the
    // theme's "open the size sheet" handler)
    if (cardBtn) {
      cardBtn.addEventListener(
        'click',
        function (ev) {
          if (!mq.matches || !picker) return;
          ev.preventDefault();
          ev.stopImmediatePropagation();
          if (!picked()) {
            picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
            picker.classList.remove('nc-pick-nudge');
            void picker.offsetWidth;
            picker.classList.add('nc-pick-nudge');
            return;
          }
          var target = visible(notifyBtn) ? notifyBtn : addBtn;
          if (target && !target.disabled) target.click();
        },
        true
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
